import { FC } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './ContactUsGetInTouch.module.scss';

export const ContactUsGetInTouch: FC = () => {
  const content = getMicrocopy(MICROCOPY.HYGIENE_CONTACT_US_GET_IN_TOUCH_CONTENT, true);
  const hours = getMicrocopy(MICROCOPY.HYGIENE_CONTACT_US_GET_IN_TOUCH_HOURS, true);

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.content}>{content}</div>
        <div>
          <div className={styles.hours}>{hours}</div>
        </div>
      </div>
    </section>
  );
};
